import { formatDateForDisplay } from '../../accessibility-trends-chart/helpers/dateFormatHelpers';
import { CHART_TEXT } from '../constants';

interface TooltipFormatterContext {
	date: string;
	count: number;
}

const createTooltipContent = (date: string, count: number): string => {
	const formattedDate = formatDateForDisplay(date);
	return `${CHART_TEXT.TOOLTIP.COUNT_LABEL} ${count}<br/> ${CHART_TEXT.TOOLTIP.DATE_LABEL} ${formattedDate}`;
};

export function tooltipFormatter(): string {
	if (this != null) {
		const point = this as TooltipFormatterContext;
		return createTooltipContent(point.date, point.count);
	}

	return '';
}
